import { initializeApp } from "firebase/app";
import { env } from "./env";

const firebaseConfig = {
  apiKey: env.REACT_APP_FIREBASE_API_KEY,
  authDomain: env.REACT_APP_AUTH_DOMAIN,
  projectId: env.REACT_APP_PROJECT_ID,
  messagingSenderId: env.REACT_APP_MESSAGING_SEND_ID,
  appId: env.REACT_APP_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
